import { ReactElement, useEffect } from 'react'
import { SectionTitle, FlexWrapper, PageWrapper } from '../../../components'
import { colors } from '../../../const/theme'
import strings from '../../../locale/en'
import DashboardCount from './DashboardCount'
import * as Highcharts from 'highcharts'
import drilldown from 'highcharts/modules/drilldown'
import { HighChartUI } from './subcomponents'
import useBreakpoint from 'use-breakpoint'
import BREAKPOINTS from '../../../const/breakpoint'
import {
  determineCoachingCenterOptions,
  determineBranchesOptions
} from './helpers'
import { useDispatch, useSelector } from 'react-redux'
import { getCounts } from '../../../redux/Dashboard/api'
import { RootState } from '../../../redux/store'
import { ROLE } from '../../../helpers/determineMenu'
import { FilterFlexWrapper } from '../../../components/FlexWrapper'
drilldown(Highcharts)

const Dashboard = (): ReactElement => {
  const {
    usersId = '',
    getCount: {
      batchCount,
      branchCount,
      teacherCount,
      studentCount
    }, 
    role
  } = useSelector(
    (state: RootState) => ({
      usersId: state.user.userInfo?.userDetail.usersId,
      role: state.user.userInfo?.role,
      getCount: state.dashboard.getCount
    })
  )

  const { breakpoint } = useBreakpoint(BREAKPOINTS)
  const isMobile = breakpoint === 'mobile'

  const dispatch = useDispatch()

  const shouldShowInstituteandAdmin = role === ROLE.ADMIN || role === ROLE.INSTITUTE_ADMIN

  const {
    menu: {
      admin: {
        dashboardMenu: { title, coachingCenters, branches, batched, students, teachers }
      }
    }
  } = strings

  useEffect(() => {
    dispatch(getCounts(usersId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <SectionTitle title={title} hasBorder />
      <FlexWrapper>
        {shouldShowInstituteandAdmin && (
          <>
            <DashboardCount
              title={coachingCenters}
              subtitle={'0'}
              color={colors.darkWine}
            />
            <DashboardCount
              title={branches}
              subtitle={branchCount}
              color={colors.anchor}
            />
            <DashboardCount
              title={batched}
              subtitle={batchCount}
              color={colors.anchor}
            />
            <DashboardCount

              title={teachers}
              subtitle={teacherCount}
              color={colors.anchor}
            />
            <DashboardCount
              title={students}
              subtitle={studentCount}
              color={colors.anchor} />
          </>
        )}
      </FlexWrapper>
      <FilterFlexWrapper>
        <HighChartUI
          containerProps={{ style: { width: isMobile ? '100%' : '50%' } }}
          highcharts={Highcharts}
          options={determineCoachingCenterOptions()}
        />
        <HighChartUI
          containerProps={{ style: { width: isMobile ? '100%' : '50%' } }}
          highcharts={Highcharts}
          options={determineBranchesOptions()}
        />
      </FilterFlexWrapper>
    </PageWrapper>
  )
}

export default Dashboard
